import styled from '@emotion/styled';
import shieldUrl from '@/assets/icons/shield.svg?url';

const PaymentWrapper = styled.div`
  font-size: 11px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.87px;
  font-weight: 600;
`;

const Row = styled.div<{ $fadeIn?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  animation: ${({ $fadeIn }) => ($fadeIn ? 'fadeIn 0.18s ease' : 'none')};

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const Icon = styled.img`
  width: 15px;
  height: 15px;
`;

interface NoPayProps {
  trialEnabled?: boolean;
}

export function NoPay({ trialEnabled = true }: NoPayProps) {
  return (
    <PaymentWrapper>
      <Row key={trialEnabled ? 'trial' : 'cancel'} $fadeIn>
        <Icon src={shieldUrl} alt="" width={15} height={15} />
        <span>{trialEnabled ? 'NO PAYMENT NOW' : 'CANCEL ANYTIME'}</span>
      </Row>
    </PaymentWrapper>
  );
}
